import makeService from './api';

export default makeService('tool_refs');
